export var SIGNAL_FONT_VARIANT = 'SIGNAL_FONT_VARIANT/';